/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import TopBarItems from "../../connection/webrtc/top-bar-items/TopBarItems";
import CartCard from "../cart/CartCard";
import CountdownTimer from "../../utils/Countdown";
import config, { HTTP_STATUS } from "../../config/config";
import StartConversation from "../start-conversation/StartConversation"

function CafeName() {
  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        align: "center",
      }}
    >
      <Typography
        variant='h4'
        color='#77b900'
        sx={{
          m: 0,
          padding: 0,
          marginBottom: 0,
        }}
      >
        {config.appTitle}
      </Typography>
    </Box>
  );
}

function TopBar({micEnabled, handleMicrophoneUpdate}) {
  const checkoutLoadingStatus = useSelector((state) => state.cart.checkoutCartLoadingStatus);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if(checkoutLoadingStatus === HTTP_STATUS.FULFILLED) {
      enqueueSnackbar("Order successful", { variant: "success" });
    } else if(checkoutLoadingStatus === HTTP_STATUS.REJECTED) {
      enqueueSnackbar("Order unsuccessful, could not contact server", { variant: "error" });
    }
  }, [checkoutLoadingStatus]);
 
  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        align: "center",
        paddingLeft: { xs: 0, md: 2.6 },
        paddingRight: { xs: 0, md: 2.6 },
        paddingTop: { xs: 0, md: 1.9 },
        paddingBottom: { xs: 0, md: 1.9 },
        background: "#2B2B2B",
        borderRadius: { xs: "0 0 0 0", md: "15px 15px 0 0" },
        boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.4)",
        border: "1px solid #424242",
      }}
    >
      <TopBarItems
        micEnabled={micEnabled}
        handleMicrophoneUpdate={handleMicrophoneUpdate}
      />
      <Box
        component='div'
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingRight: { xs: 0, md: config.enableCamera === false ? 0 : 12},
        }}
      >
        <CafeName />
        {config.enableCountdown && <CountdownTimer />}
      </Box>
      
      {(config.enableCamera === false) &&
      <div style={{ display: "flex" }}>
      <StartConversation />
    </div>
    }

      <div style={{ display: "flex" }}>
        <CartCard />
      </div>
    </Grid>
  );
}

export default TopBar;
